/**
 * PreviewManager Module
 * Handles sample preview and canvas preview management
 */

export class PreviewManager {
    canvas: HTMLCanvasElement;

    constructor(canvas: HTMLCanvasElement) {
        this.canvas = canvas;
        this.initializePreview();
    }

    /**
     * Initialize preview state (show sample, hide canvas)
     */
    initializePreview(): void {
        const samplePreview = document.querySelector('.sample-preview');
        const canvas = this.canvas;
        const previewContent = document.querySelector('.preview-content');
        
        if (samplePreview) {
            samplePreview.classList.remove('hidden');
        }
        if (canvas) {
            canvas.classList.add('hidden');
        }
        if (previewContent) {
            previewContent.classList.add('show-sample');
            previewContent.classList.remove('show-canvas');
        }
    }

    /**
     * Update sample preview styling and content
     */
    updateSamplePreview(): void {
        const sampleText = document.querySelector('.sample-text') as HTMLElement;
        const bgColorInput = document.getElementById('backgroundColorText') as HTMLInputElement;
        const textColorInput = document.getElementById('textColorText') as HTMLInputElement;
        const fontSizeInput = document.getElementById('fontSize') as HTMLInputElement;
        const fontFamilyInput = document.getElementById('fontFamily') as HTMLSelectElement;
        const textContentInput = document.getElementById('textContent') as HTMLInputElement;
        
        const backgroundColor = bgColorInput?.value || '#3B82F6';
        const textColor = textColorInput?.value || '#111827';
        const fontSize = parseInt(fontSizeInput?.value || '24');
        const fontFamily = fontFamilyInput?.value || 'Arial, sans-serif';
        const textContent = textContentInput?.value || '';
        
        if (sampleText) {
            const samplePreview = document.querySelector('.sample-preview') as HTMLElement;
            if (samplePreview) {
                samplePreview.style.backgroundColor = backgroundColor;
            }
            
            sampleText.style.color = textColor;
            sampleText.style.fontSize = `${Math.min(fontSize, 32)}px`; // Cap sample preview font size
            sampleText.style.fontFamily = fontFamily;
            
            // Update sample text content
            if (textContent.trim()) {
                sampleText.textContent = textContent.length > 20 ? textContent.substring(0, 20) + '...' : textContent;
            } else {
                sampleText.textContent = '';
            }
        }
    }

    /**
     * Show canvas and hide sample preview
     */
    showCanvasPreview(): void {
        this.canvas.classList.remove('hidden');
        const samplePreview = document.querySelector('.sample-preview');
        const previewContent = document.querySelector('.preview-content');
        
        if (samplePreview) {
            samplePreview.classList.add('hidden');
        }
        if (previewContent) {
            previewContent.classList.add('show-canvas');
            previewContent.classList.remove('show-sample');
        }
    }

    /**
     * Reset to sample preview state
     */
    resetToSamplePreview(): void {
        const samplePreview = document.querySelector('.sample-preview');
        const canvas = this.canvas;
        const previewContent = document.querySelector('.preview-content');
        
        if (samplePreview) {
            samplePreview.classList.remove('hidden');
        }
        if (canvas) {
            canvas.classList.add('hidden');
        }
        if (previewContent) {
            previewContent.classList.add('show-sample');
            previewContent.classList.remove('show-canvas');
        }
    }

    /**
     * Update canvas size
     * @param width - Canvas width
     * @param height - Canvas height
     */
    updateCanvasSize(width: number, height: number): void {
        this.canvas.width = width;
        this.canvas.height = height;
    }
}
